import React from 'react';
import { withRouter } from 'react-router-dom';
import './index.scss';

const Terms = () => {
  return (
    <div>
      <div class="terms__header">
        <h2>TERMS AND CONDITIONS</h2>
      </div>
      <div class="terms__content">
        <div>
          <h4>1. INTERPRETATION</h4>

          <p>
            1.1 The definitions and rules of interpretation in this clause apply
            in this Contract.
          </p>
          <p>
            &ldquo;Authorised Users&rdquo;: those employees, agents and
            independent contractors of the Client who are authorised by the
            Client to use the Services, as further described in clause 2.2(b).
          </p>
          <p>
            &ldquo;Booking&rdquo;: an agreement between a Customer and the
            Client for a reservation of a table (or other seating or standing
            area) and any additional items ordered by the Customer.
          </p>
          <p>
            &ldquo;Booking Details&rdquo;: the details provided by Customers to
            Fatsoma Tabb to enable Fatsoma Tabb to process Customer Payments.
          </p>
          <p>
            &ldquo;Booking Fee&rdquo;: such percentage of each deposit within a
            Customer Payment that the Client elects to charge Customers as its
            booking fee for accepting Bookings. &ldquo;Business Day&ldquo;: a
            day other than a Saturday, Sunday or public holiday in England when
            banks in London are open for business.
          </p>
          <p>
            &ldquo;Client&rdquo;: the entity named in the Contract Details.
            &ldquo;Client Data&ldquo;: data inputted by the Client, or Fatsoma
            Tabb on the Client's behalf, for the purpose of using the Services.
          </p>
          <p>
            &ldquo;Client Payment&rdquo;: the Customer Payment less the
            Transaction Fee.
          </p>
          <p>
            &ldquo;Confidential Information&rdquo;: information that is
            proprietary or confidential and is either clearly labelled as such
            or identified as Confidential Information. &ldquo;Contract&rdquo;:
            the Contract Details and these Conditions. &ldquo;Contract
            Details&rdquo;: the details of the Client and Transaction Fee to
            which these Conditions are appended.
          </p>
          <p>
            &ldquo;Customer&rdquo;: a customer of the Client making a Booking.
          </p>
          <p>
            &ldquo;Customer Payment&rdquo;: the sum payable for a Booking by a
            Customer via the Web App Link, comprised of a deposit, any
            additional items ordered by the Customer, and any Booking Fee.
          </p>
          <p>
            &ldquo;Data Protection Legislation&rdquo;: (i) the Data Protection
            Act 1998 until the implementation of the General Data Protection
            Regulation ((EU) 2016/679) (&ldquo;GDPR&rdquo;), (ii) GDPR unless
            and until it is no longer directly applicable in the UK, GDPR and
            any national implementing laws, regulations and secondary
            legislation, as amended or updated from time to time, in the UK and
            then (ii) any successor legislation to the GDPR or the Data
            Protection Act 1998.
          </p>
          <p>
            &ldquo;Effective Date&rdquo;: the date of this Contract as shown in
            the Contract Details.
          </p>
          <p>
            &ldquo;Initial Term&rdquo;: the period of 24 months from the
            Effective Date.
          </p>
          <p>
            &ldquo;Intellectual Property Rights&rdquo;: patents, utility models,
            rights to inventions, copyright and neighbouring and related rights,
            trademarks and service marks, business names and domain names,
            rights in get-up and trade dress, goodwill and the right to sue for
            passing off or unfair competition, rights in designs, database
            rights, rights to use, and protect the confidentiality of,
            confidential information (including know-how and trade secrets), and
            all other intellectual property rights, in each case whether
            registered or unregistered and including all applications and rights
            to apply for and be granted, renewals or extensions of, and rights
            to claim priority from, such rights and all similar or equivalent
            rights or forms of protection which subsist or will subsist now or
            in the future in any part of the world. &ldquo;Normal Business
            Hours&ldquo;: 8.00 am to 6.00 pm local UK time, each Business Day.
          </p>
          <p>
            &ldquo;Payment System Provider&rdquo;: the payment system provider
            used by Fatsoma Tabb from time to time.
          </p>
          <p>
            &ldquo;Refund&rdquo;: a refund of the Customer Payment and Booking
            Fee made to a Customer in accordance with clause 7.
          </p>
          <p>
            &ldquo;Renewal Period&rdquo;: the period described in clause 10.1.
            &ldquo;Reservation Date&rdquo;: the date for which a Booking is
            made.
          </p>
          <p>
            &ldquo;Services&rdquo;: the subscription services provided by
            Fatsoma to the Client under this Contract via
            https://tabb-admin.fatsoma.com or any other website notified to the
            Client by Fatsoma from time to time.
          </p>
          <p>
            &ldquo;Software&rdquo;: the online software applications provided by
            Fatsoma Tabb as part of the Services.
          </p>
          <p>
            &ldquo;Fatsoma Tabb&rdquo;: A service of Fatsoma Limited, a company
            registered in England and Wales with company number 05495880 and
            whose registered office is at 6th Floor, The Hive, 47 - 49 Lever
            Street, Manchester M1 1FN
          </p>
          <p>&ldquo;Term&rdquo;: has the meaning given in clause 10.1.</p>
          <p>
            Third Party Suppliers: Stripe, Amazon Web Services and any other
            third party supplier Fatsoma works with to provide the Services from
            time to time.
          </p>
          <p>
            &ldquo;Third Party Terms&rdquo;: the terms of any Third Party
            Supplier with which the Client is required to comply, as set out in
            the Contract Details or as provided by Tabb to the Client from time
            to time.
          </p>
          <p>
            &ldquo;Transaction Fee&rdquo;: the percentage of the Customer
            Payment (plus VAT thereupon) charged by Fatsoma and deducted from
            the Client Payment as set out in the Contract Details and in clause
            7.
          </p>
          <p>
            &ldquo;Virus&rdquo;: any thing or device (including any software,
            code, file or programme) which may: prevent, impair or otherwise
            adversely affect the operation of any computer software, hardware or
            network, any telecommunications service, equipment or network or any
            other service or device; prevent, impair or otherwise adversely
            affect access to or the operation of any programme or data,
            including the reliability of any programme or data (whether by
            re-arranging, altering or erasing the programme or data in whole or
            part or otherwise); or adversely affect the user experience,
            including worms, trojan horses, viruses and other similar things or
            devices.
          </p>
          <p>
            &ldquo;Webapp Link&rdquo;: the link provided by Fatsoma Tabb to the
            Client to be used by Customers to pay Customer Payments.
          </p>

          <p>
            1.2. A person includes an individual, corporate or unincorporated
            body (whether or not having separate legal personality).
          </p>

          <p>
            1.3. Unless The Context Otherwise Requires,words in the singular
            shall include the plural and in the plural shall include the
            singular, and a reference to one gender shall include a reference to
            the other genders.
          </p>

          <p>
            1.4. A reference to a statute or statutory provision is a reference
            to it as it is in force as at the date of this Contract, and shall
            include all subordinate legislation made as at the date of this
            Contract under that statute or statutory provision.
          </p>

          <p>
            1.5. A reference to writing or written includes faxes and e-mail.
          </p>
        </div>

        <div>
          <h4>2. USE OF THE SERVICES</h4>

          <p>
            2.1. Subject to the Client&rsquo;s compliance with the terms and
            conditions of this Contract, Fatsoma hereby grants to the Client a
            non-exclusive, non-transferable right, without the right to grant
            sublicenses, to permit the Authorised Users to use the Services
            during the Term solely for the purposes set out in this Contract.
          </p>

          <p>
            2.2. In relation to the Authorised Users, the Client undertakes
            that:
          </p>
          <p>
            (a) each Authorised User shall keep a secure password for his use of
            the Services, which Fatsoma recommends be changed once each month,
            and that each Authorised User shall keep his password confidential;
            and
          </p>
          <p>
            (b) it shall maintain a written, up to date list of current
            Authorised Users and provide such list to Fatsoma within 5 Business
            Days of Fatsoma's written request at any time or times, and shall
            permit Fatsoma to carry out audits from time to time in order to
            establish the name and password of each AuthorisedUser.
          </p>

          <p>
            2.3. The Client shall not access, store, distribute or transmit any
            Viruses, or any material during the course of its use of the
            Services that is unlawful, harmful, threatening, defamatory,
            obscene, infringing, harassing or racially or ethnically offensive,
            facilitates illegal activity, depicts sexually explicit images, is
            discriminatory or is otherwise illegal, and Fatsoma reserves the
            right, without liability or prejudice to its other rights to the
            Client, to disable the Client's access to any material that breaches
            the provisions of this clause.
          </p>

          <p>2.4. The Client shall not:</p>
          <p>
            (a) except as may be allowed by any applicable law which is
            incapable of exclusion by agreement between the parties and except
            to the extent expressly permitted under this Contract:
          </p>
          <p>
            (i). attempt to copy, modify, duplicate, create derivative works
            from, frame, mirror, republish, download, display, transmit, or
            distribute all or any portion of the Software in any form or media
            or by any means; or
          </p>
          <p>
            (ii). attempt to de-compile, reverse compile, disassemble, reverse
            engineer or otherwise reduce to human-perceivable form all or any
            part of the Software; or
          </p>
          <p>
            (b) access all or any part of the Services in order to build a
            product or service which competes with the Services; or
          </p>
          <p>
            (c) subject to clause 12.8, license, sell, rent,lease,transfer,
            assign, distribute, display, disclose, or otherwise commercially
            exploit, or otherwise make the Services available to any third party
            except the Authorised Users, or
          </p>
          <p>
            (d) attempt to obtain, or assist third parties in obtaining, access
            to the Services, other than as provided under this clause 2.4.
          </p>

          <p>
            2.5. The Client shall use all reasonable endeavours to prevent any
            unauthorised access to, or use of, the Services and, in the event of
            any such unauthorised access or use, promptly notify Fatsoma.
          </p>
        </div>

        <div>
          <h4>3. SERVICES</h4>

          <p>
            3.1. Fatsoma shall use commercially reasonable endeavours to make
            the Services available 24 hours a day, seven days a week, except for
            emergency maintenance and/or maintenance performed outside of Normal
            Business Hours.
          </p>

          <p>3.2. The Services are provided on the following basis:</p>
          <p>
            (a) only one Deposit will be taken per Customer per Reservation
            Date;
          </p>
          <p>
            (b) each Customer&rsquo;s debit/credit card details must match the
            Booking Details;
          </p>
          <p>
            (c) the Client shall not provide the Webapp Link to a Customer it
            believes or should reasonably be aware to be conducting fraudulent,
            illegal or criminal activity;
          </p>
          <p>
            (d) the Client is solely liable for and indemnifies Fatsoma for any
            losses, claims, costs or damages suffered or incurred by Fatsoma in
            relation to any fraudulent, illegal or criminal activity by
            anyCustomer;
          </p>
          <p>
            (e)the Client is responsible for ensuring that the Webapp Link is
            sent to Customers; and
          </p>
          <p>
            (f) the Client will comply with Fatsoma&rsquo;s recommendations and
            requirements for checking and verifying the identity of Customers
            (to include identity checks as required) and will take all
            reasonable steps to ensure that Customers comply with such
            recommendations and requirements.
          </p>
        </div>

        <div>
          <h4>4. CLIENT DATA AND PERSONAL DATA</h4>

          <p>
            4.1. The Client shall own all right, title and interest in and to
            all of the Client Data and shall have sole responsibility for the
            legality, reliability, integrity, accuracy and quality of the Client
            Data. In the event of any loss or damage to Client Data, the
            Client's sole and exclusive remedy shall be for Fatsoma to use
            reasonable commercial endeavours to restore the lost or damaged
            Client Data from the latest back-up of such Client Data maintained
            by Fatsoma. Fatsoma shall not be responsible for any loss,
            destruction, alteration or disclosure of Client Data caused by any
            third party.
          </p>

          <p>
            4.2. Where Fatsoma processes the personal data of Customers on the
            Client's behalf when providing the Services, the parties record
            their intention that the Client Shall Be the data controller and
            Fatsoma shall be a data processor and in any such case:
          </p>
          <p>
            (a) the Client acknowledges and agrees that the personal data may be
            transferred or stored outside the EEA or the country where the
            Client and the Customers are located in order to carry out the
            Services and Fatsoma's other obligations under this Contract;
          </p>
          <p>
            (b) the Client shall ensure that Fatsoma may lawfully use, process
            and transfer the personal data in accordance with this Contract on
            the Client's behalf;
          </p>
          <p>
            (c) the Client shall ensure that the relevant third parties,
            including but not limited to Customers, have been informed of, and
            have given their consent to, such use, processing, and transfer as
            required by all applicable Data Protection Legislation; and
          </p>
          <p>
            (d) each party shall take appropriate technical and organisational
            measures against unauthorised or unlawful processing of the personal
            data or its accidental loss, destruction or damage.
          </p>
        </div>

        <div>
          <h4>5. FATSOMA'S OBLIGATIONS</h4>

          <p>
            5.1 Fatsoma undertakes that the Services will be performed with
            reasonable skill and care.
          </p>

          <p>
            5.2 The undertaking at clause 5.1 shall not apply to the extent of
            any non-conformance which is caused by use of the Services contrary
            to Fatsoma's instructions, or modification or alteration of the
            Services by any party other than Fatsoma. If the Services do not
            conform with the foregoing undertaking, Fatsoma will, at its
            expense, use all reasonable commercial endeavours to correct any
            such non-conformance promptly, or provide the Client with an
            alternative means of accomplishing the desired performance. Such
            correction or substitution constitutes the Client's sole and
            exclusive remedy for any breach of the undertaking set out in clause
            5.1. Notwithstanding the foregoing, Fatsoma:
          </p>
          <p>
            (a) does not warrant that the Client's use of the Services will be
            uninterrupted or error-free; or that the Services, and/or the
            information obtained by the Client through the Services will meet
            the Client's requirements; and
          </p>
          <p>
            (b) is not responsible for any delays, delivery failures, or any
            other loss or damage resulting from the transfer of data over
            communications networks and facilities, including the internet, and
            the Client acknowledges that the Services may be subject to
            limitations, delays and other problems inherent in the use of such
            communications facilities.
          </p>

          <p>
            5.3 This Contract shall not prevent Fatsoma from entering into
            similar agreements with third parties, or from independently
            developing, using, selling or licensing products and/or services
            which are similar to those provided under this Contract.
          </p>
          <p>
            5.4 Fatsoma warrants that it has and will maintain all necessary
            licences, consents, and permissions necessary for the performance of
            its obligations under this Contract.
          </p>
          <p>
            5.5 Fatsoma shall install Software, create profiles and provide
            training to Authorised Users.
          </p>
        </div>

        <div>
          <h4>6. CLIENT'S OBLIGATIONS</h4>

          <p>6.1 The Client shall:</p>
          <p>
            (a) be responsible for meeting Customers' Bookings in accordance
            with the agreed terms of the Booking between the Client and the
            Customer and acknowledges that Fatsoma's role is only to arrange
            payment of Customer Payments and Client Payments;
          </p>
          <p>
            (b) upon agreement of a Booking with a Customer, send to the
            Customer the Webapp Link;
          </p>
          <p>
            (c) provide Fatsoma with all necessary co-operation in relation to
            this Contract; and all necessary access to such information as may
            be required by Fatsoma in order to provide the Services;
          </p>
          <p>
            (d) comply with all applicable laws and regulations with respect to
            its activities under or in relation to this Contract;
          </p>
          <p>
            (e) ensure that the Authorised Users use the Services in accordance
            with the terms and conditions of this Contract and shall be
            responsible for any Authorised User's breach of this Contract;
          </p>
          <p>
            (f) notify Fatsoma within 24 hours if it agrees to a refund of any
            Customer Payment whether partial or in full; and
          </p>
          <p>
            (g) ensure that its network and systems comply with the relevant
            specifications provided by Fatsoma from time to time.
          </p>

          <p>
            6.2 Fatsoma uses Third Party Suppliers to assist in the performance
            of the Services. The Client agrees to be bound by the relevant Third
            Party Terms as set out in the Contract Details or provided by
            Fatsoma from time to time.
          </p>
        </div>

        <div>
          <h4>7. CHARGES, PAYMENT AND REFUNDS</h4>
          <p>
            7.1 Fatsoma will take Customer Payments using its Payment Service
            Provider and the parameters for the amount of deposit, other items
            available to order and the Booking Fee (if any) set by the Client.
          </p>
          <p>
            7.2 Transaction Fees are deducted by Fatsoma from Customer Payments
            received, and Client Payments are then sent to the Client's bank
            account on a weekly basis on a day selected by the Client.
          </p>
          <p>
            7.3 Client Payments are sent within 7-14 days of receipt of Customer
            Payments. There may be delays in Client Payments if Fatsoma or its
            Payment Service Provider is required to investigate a Customer or a
            payment. Should Fatsoma become aware of any Client Payments being
            delayed, it will make the Client aware as soon as possible if such
            action is in accordance with all applicable laws, regulations and
            guidance.
          </p>
          <p>
            7.4 Transaction Fees are detailed in a monthly VAT invoice raised on
            or about the first Monday of each month which details all
            Transaction Fees and any administrative fees charged in relation to
            refunds or chargebacks (&ldquo;Admin Charges&rdquo;) in the
            preceding month.
          </p>
          <p>
            7.5 The Client will notify Fatsoma promptly if it becomes aware of
            any dispute, chargeback or refund required of a Customer Payment
            and, in the case of a refund, whether the refund is full or partial
            and whether the Client shall refund the Booking Fee as well as any
            other sums owed. In any such case, or if Fatsoma becomes aware of
            any chargebacks or fraudulent or duplicated payments, Fatsoma shall,
            unless it is at fault for a duplicated payment, retain (or in the
            case of a chargeback, re-charge) its Transaction Fee and shall apply
            an Admin Charge which will be deducted from future Client Payments
            or taken from the Client's bank account in accordance with the Third
            Party Terms of Fatsoma Payment Service Provider.
          </p>
          <p>
            7.6 Fatsoma shall be entitled to increase the Transaction Fee at the
            start of each Renewal Period upon 30 days prior notice to the Client
            and the definition of Transaction Fee shall be deemed to have been
            amended accordingly.
          </p>
          <p>
            7.7 For each 30 day period where a Customer Payment is not made,
            Fatsoma reserves the right to charge a fee of £50 plus VAT. For the
            avoidance of doubt, the first 30 day period commences from the
            Effective Date. Thereafter, it commences on the day after a Customer
            Payment was made.
          </p>
        </div>

        <div>
          <h4>8. INTELLECTUAL PROPERTY RIGHTS</h4>
          <p>
            8.1 The Client acknowledges and agrees that Fatsoma and/or its
            licensors own all Intellectual Property Rights in the Services.
            Except as expressly stated herein, this Contract does not grant the
            Client any rights to, under or in, any Intellectual Property Rights
            in respect of the Services.
          </p>
          <p>
            8.2 The Client grants to Fatsoma a non-exclusive, personal,
            royalty-free licence during the Term to use its Intellectual
            Property Rights in relation to the Services to the extent necessary
            for Fatsoma to carry out the Services.
          </p>
          <p>
            8.3 At the end of the Term, Fatsoma shall cease to use the Client's
            Intellectual Property Rights and shall return any physical
            embodiment of such Intellectual Property Rights (including any
            copies) in its possession or control to the Client.
          </p>
          <p>
            8.4 Each party shall immediately give written notice to the other
            party of any actual, threatened or suspected infringement of the
            other party's Intellectual Property Rights of which it becomes
            aware.
          </p>
        </div>

        <div>
          <h4>9. LIMITATION OF LIABILITY</h4>
          <p>
            9.1 Except as expressly and specifically provided in this Contract:
          </p>
          <p>
            (a) the Client assumes sole responsibility for Bookings and
            relationships with Customers related to the use of the Services by
            the Client. Fatsoma shall have no liability for any damage caused by
            errors or omissions in any information provided to Fatsoma by the
            Client in connection with the Services, or any actions taken by
            Fatsoma at the Client's direction;
          </p>
          <p>
            (b) all warranties, representations, conditions and all other terms
            of any kind whatsoever implied by statute or common law are, to the
            fullest extent permitted by applicable law, excluded from this
            Contract; and
          </p>
          <p>
            (c) the Services are provided to the Client on an &ldquo;as
            is&ldquo; basis.
          </p>

          <p>9.2 Nothing in this Contract excludes the liability of Fatsoma:</p>
          <p>
            (a) for death or personal injury caused by Fatsoma's negligence; or
          </p>
          <p>(b) for fraud or fraudulent misrepresentation.</p>

          <p>9.3 Subject to clause 9.1 and clause 9.2:</p>
          <p>
            (a) Fatsoma shall not be liable whether in tort (including for
            negligence or breach of statutory duty), contract,
            misrepresentation, restitution or otherwise for any loss of profits,
            loss of business, depletion of goodwill and/or similar losses or
            loss or corruption of data or information, or pure economic loss, or
            for any special, indirect or consequential loss, costs, damages,
            charges or expenses however arising under this Contract; and
          </p>
          <p>
            (b) Fatsoma's total aggregate liability in contract tort (including
            negligence or breach of statutory duty), misrepresentation,
            restitution or otherwise, arising in connection with the performance
            or contemplated performance of this Contract shall be limited to the
            total Transaction Fees charged during the 12 months immediately
            preceding the date on which the claim arose.
          </p>
        </div>

        <div>
          <h4>10. TERM AND TERMINATION</h4>

          <p>
            10.1 This Contract shall, unless otherwise terminated as provided in
            this clause 10, commence on the Effective Date, or the date at which
            the Client first logs into their Dashboard whether or not the Client
            has signed these Terms, and shall continue for the Initial Term and,
            thereafter, this Contract shall be automatically renewed for
            successive periods of 12 months (each a &ldquo;Renewal
            Period&ldquo;), unless:
          </p>
          <p>
            (a) either party notifies the other party of termination, in
            writing, at least 3 months before the end of the Initial Term or any
            Renewal Period, in which case this Contract shall terminate upon the
            expiry of the applicable Initial Term or Renewal Period; or
          </p>
          <p>
            (b) otherwise terminated in accordance with the provisions of this
            Contract; and the Initial Term together with any subsequent Renewal
            Periods shall constitute the &ldquo;Term&ldquo;.
          </p>

          <p>
            10.2 Without affecting any other right or remedy available to it,
            either party may terminate this Contract with immediate effect by
            giving written notice to the other party if:
          </p>
          <p>
            (a) the other party commits a material breach of any other term of
            this Contract which breach is irremediable or (if such breach is
            remediable) fails to remedy that breach within a period of 14 days
            after being notified in writing to doso;
          </p>
          <p>
            (b) the other party repeatedly breaches any of the terms of this
            Contract in such a manner as to reasonably justify the opinion that
            its conduct is inconsistent with it having the intention or ability
            to give effect to the terms of this Contract;
          </p>
          <p>
            (c) the other party suspends, or threatens to suspend, or ceases or
            threatens to cease to carry on all or a substantial part of its
            business; or
          </p>
          <p>
            (d) the other party takes any step or action in connection with its
            entering administration, provisional liquidation or any composition
            or arrangement with its creditors (other than in relation to a
            solvent restructuring), being wound up (whether voluntarily or by
            order of the court, unless for the purpose of a solvent
            restructuring), having a receiver appointed to any of its assets or
            ceasing to carry on business or, if the step or action is taken in
            another jurisdiction, in connection with any analogous procedure in
            the relevant jurisdiction;
          </p>
          <p>
            (e) the other party&rsquo;s financial position deteriorates to such
            an extent that in the terminating party&rsquo;s opinion the other
            party&rsquo;s capability to adequately fulfil its obligations under
            the Contract has been placed in jeopardy.
          </p>

          <p>
            10.3. Fatsoma may suspend or terminate (at its sole discretion) the
            Services and/or this Contract immediately if:
          </p>
          <p>
            (a) the Client has more than 1% of its total Customer Payments
            charged back; or
          </p>
          <p>
            (b) the Client is involved in any fraud or other illegal or criminal
            activity; or
          </p>
          <p>(c) the Client breaches the Third Party Terms.</p>

          <p>10.4 On termination of this Contract for any reason:</p>
          <p>
            (a) all licences granted under this Contract shall immediately
            terminate and the Client shall immediately cease all use of the
            Services;
          </p>
          <p>
            (b) Fatsoma may destroy or otherwise dispose of any of the Client
            Data in its possession; and
          </p>
          <p>
            (c) any rights, remedies, obligations or liabilities of the parties
            that have accrued up to the date of termination shall not be
            affected or prejudiced.
          </p>
        </div>

        <div>
          <h4>11. FORCE MAJEURE</h4>
          <p>
            Fatsoma shall have no liability to the Client under this Contract if
            it is prevented from or delayed in performing its obligations under
            this Contract, or from carrying on its business, by acts, events,
            omissions or accidents beyond its reasonable control, provided that
            the Client is notified of such an event and its expected duration.
          </p>
        </div>

        <div>
          <h4>12. GENERAL</h4>
          <p>12.1 Confidential Information:</p>
          <p>
            (a) Each party may be given access to Confidential Information from
            the other party in order to perform its obligations under this
            Contract. A party's Confidential Information shall not be deemed to
            include information that is or becomes publicly known other than
            through any act or omission of the receiving party, was in the other
            party's lawful possession before the disclosure, is lawfully
            disclosed to the receiving party by a third party without
            restriction on disclosure, or is
          </p>{' '}
          independently developed by the receiving party, which independent
          development can be shown by written evidence.
          <p>
            (b) Each party shall hold the other's Confidential Information in
            confidence and not make the other's Confidential Information
            available to any third party, or use the other's Confidential
            Information for any purpose other than the implementation of this
            Contract.
          </p>
          <p>
            12.2 A party may disclose Confidential Information to the extent
            such Confidential Information is required to be disclosed by law, by
            any governmental or other regulatory authority or by a court or
            other authority of competent jurisdiction.
          </p>
          <p>
            12.3 Variation: These Conditions may be varied from time to time by
            Fatsoma giving written notice to the Client.
          </p>
          <p>
            12.4 Waiver: No failure or delay by a party to exercise any right or
            remedy provided under this Contract or by law shall constitute a
            waiver of that or any other right or remedy, nor shall it prevent or
            restrict the further exercise of that or any other right or remedy.
            No single or partial exercise of such right or remedy shall prevent
            or restrict the further exercise of that or any other right or
            remedy.
          </p>
          <p>
            12.5 Rights and Remedies: Except as expressly provided in this
            Contract, the rights and remedies provided under this Contract are
            in addition to, and not exclusive of, any rights or remedies
            provided by law.
          </p>
          <p>
            12.6 Severance: If any provision or part-provision of the Contract
            is or becomes invalid, illegal or unenforceable, it shall be deemed
            modified to the minimum extent necessary to make it valid, legal and
            enforceable. If such modification is not possible, the relevant
            provision or part-provision shall be deemed deleted. Any
            modification to or deletion of a provision or part-provision under
            this clause shall not affect the validity and enforceability of the
            rest of the Contract
          </p>
          <p>12.7 Entire Agreement:</p>
          <p>
            (a) This Contract constitutes the entire agreement between the
            parties and supersedes and extinguishes all previous agreements,
            promises, assurances, warranties, representations and understandings
            between them, whether written or oral, relating to its subject
            matter.
          </p>
          <p>
            (b) Each party acknowledges that in entering into this Contract it
            does not rely on, and shall have no remedies in respect of, any
            statement, representation, assurance or warranty (whether made
            innocently or negligently) that is not set out in this Contract.
          </p>
          <p>
            (c) Each party agrees that it shall have no claim for innocent or
            negligent misrepresentation or negligent misstatement based on any
            statement in this Contract.
          </p>
          <p>
            (d) Nothing in this clause shall limit or exclude any liability for
            fraud.
          </p>
          <p>12.8 Assignment:</p>
          <p>
            (a) The Client shall not, without the prior written consent of
            Fatsoma, assign, transfer, charge, sub-contract or deal in any other
            manner with all or any of its rights or obligations under this
            Contract.
          </p>
          <p>
            (b) Fatsoma may at any time assign, transfer, charge, sub- contract
            or deal in any other manner with all or any of its rights or
            obligations under this Contract.
          </p>
          <p>
            12.9 Third party rights: This Contract does not confer any rights on
            any person or party (other than the parties to this Contract and,
            where applicable, their successors and permitted assigns) pursuant
            to the Contracts (Rights of Third Parties) Act 1999.
          </p>
          <p>12.10 Notices:</p>
          <p>
            (a) Any notice required to be given under this Contract shall be in
            writing and shall be delivered by hand or sent by pre-paid
            first-class post or recorded delivery post to the other party at its
            address set out in this Contract, or such other address as may have
            been notified by that party for such purposes, or sent by email to
            the other party's email address as notified by that party from time
            to time.
          </p>
          <p>
            (b) A notice delivered by hand shall be deemed to have been received
            when delivered (or if delivery is not in business hours, at 9 am on
            the first business day following delivery). A correctly addressed
            notice sent by pre-paid first-class post or recorded delivery post
            shall be deemed to have been received at the time at which it would
            have been delivered in the normal course of post. A notice sent by
            email shall be deemed to have been received at the time of
            transmission or, in the case of emails sent outside of Normal
            Business Hours, at 09.00am on the Business Day following
            transmission.
          </p>
          <p>
            12.11 Governing law and Jurisdiction: This Contract and any dispute
            or claim arising out of or in connection with it or its subject
            matter or formation (including non- contractual disputes or claims)
            shall be governed by and construed in accordance with the law of
            England and Wales and the courts of England and Wales shall have
            exclusive jurisdiction to settle any dispute or claim arising out of
            or in connection with this Contract or its subject matter or
            formation (including non- contractual disputes or claim.
          </p>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Terms);



// WEBPACK FOOTER //
// ./src/components/Policies/Terms/index.jsx